import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Select } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './styleGroupEditUser.css';
import { useGroupsStore } from '../../../../store/groups/Groups';
import { Group } from '../../../../types/Group';
import { useAuthStore } from '../../../../store/auth/auth';
import { getGroupEditDevice } from '../../../../api/devices/getEditDeviceGroup';
import { Key } from 'antd/lib/table/interface';
import { useButtonsFromAllcams } from '../../../../store/devices/useButtonsFromAllcams';
import { getEditUser } from '../../../../api/users/updateUser';
import { useUserStore } from '../../../../store/users/UserStore';

const { Option } = Select;
interface NewGroupModalProps {
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
    device: Key[];
    selectedUser?: any; // User | null
}
const GroupEditUserModal: React.FC<NewGroupModalProps> = ({ open, onOk, onCancel, device, selectedUser }) => {
    const { groups, fetchGroups } = useGroupsStore();
    const { user, SmartDVRToken } = useAuthStore();
    const [groupUID, setGroupUID] = useState<string | undefined>(undefined);
    const { setIsEditDeviceGroupModal } = useButtonsFromAllcams();
    const [form] = Form.useForm();
    const { users } = useUserStore();

    useEffect(() => {
        if (groups.length === 0) {
            fetchGroups();
        }
    }, [groups.length]);

    useEffect(() => {
        if (open) {
            let groupUids: string[] = [];
            if (device.length === 1 && selectedUser) {
                // Один пользователь
                groupUids = Array.isArray(selectedUser.groups)
                    ? (selectedUser.groups.length > 0 && typeof selectedUser.groups[0] === 'object' && 'uid' in selectedUser.groups[0]
                        ? (selectedUser.groups as { uid: string }[]).map(g => g.uid)
                        : selectedUser.groups as unknown as string[])
                    : [];
            } else if (device.length > 1) {
                // Несколько пользователей
                const selectedUsers = users.filter(u => device.includes(u.uid));
                if (selectedUsers.length === device.length) {
                    // Получаем массив массивов uid групп
                    const allGroupsArr = selectedUsers.map(u =>
                        Array.isArray(u.groups)
                            ? (u.groups.length > 0 && typeof u.groups[0] === 'object' && 'uid' in u.groups[0]
                                ? (u.groups as { uid: string }[]).map(g => g.uid)
                                : u.groups as unknown as string[])
                            : []
                    );
                    // Сортируем для сравнения
                    const sorted = allGroupsArr.map(arr => [...arr].sort());
                    const allEqual = sorted.every(arr => JSON.stringify(arr) === JSON.stringify(sorted[0]));
                    if (allEqual) {
                        groupUids = sorted[0];
                    } else {
                        groupUids = [];
                    }
                }
            }
            form.setFieldsValue({ parent_uid: groupUids });

        }
    }, [selectedUser, open, form, device, users]);

    const handleParentUidChange = (value: string) => {
        setGroupUID(value);
    };

    const getAllSubGroups = (group: Group): Group[] => {
        const subGroups: Group[] = [];
        group.sub_groups.forEach((subGroup) => {
            subGroups.push(subGroup);
            if (subGroup.sub_groups) {
                subGroups.push(...getAllSubGroups(subGroup));
            }
        });
        return subGroups;
    };

    // Объединяем группы и подгруппы в один массив
    const allGroups: Group[] = [];
    groups.forEach((group) => {
        allGroups.push(group);
        if (group.sub_groups) {
            allGroups.push(...getAllSubGroups(group));
        }
    });

    const handleOk = async () => {
        const values = await form.validateFields();
        if (!user) return;
        const promises = device.map(async (uid) => {
            const userObj = users.find(u => u.uid === uid);
            if (!userObj) return;
            const userData = {
                uid: userObj.uid,
                login: userObj.login,
                password: userObj.password || '',
                name: userObj.name,
                isAdmin: userObj.isAdmin,
                groups: values.parent_uid,
            };
            return getEditUser(SmartDVRToken, user.login, userData as any);
        });
        await Promise.all(promises);
        onOk();
        setIsEditDeviceGroupModal(false);
    };

    return (
        <Modal
            title={
                <div className="titleModal_Group">
                    <span className="spanGroup">Редактировать пользователей</span>
                    <CloseOutlined onClick={onCancel} className="closeBut_GroupEdit" />
                </div>
            }
            className="newGroup_modal"
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            width={720}
            closable={false}
            footer={
                <Button className="buttonAdd" onClick={handleOk}>
                    Сохранить
                </Button>
            }
        >
            <Form form={form}>
                <Form.Item
                    className="form_Group"
                    label={<span className="inputLabel_Group">Группа</span>}
                    name="parent_uid"
                    required={false}
                >
                    <Select
                        className="selectGroup"
                        placeholder="Введите название или выберите из списка"
                        maxCount={10}
                        mode="multiple"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        onChange={handleParentUidChange}
                    >
                        {allGroups
                            .filter((group) => group.uid !== '00000000-0000-0000-0000-000000000003')
                            .map((group) => (
                                <Option key={group.uid} value={group.uid}>
                                    {group.name}
                                </Option>
                            ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default GroupEditUserModal;
